module.exports = __webpack_public_path__ + "img/emoji07.png";